"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RaisedButtonStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RaisedButtonStyled = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\tborder-width: ", ";\n\n\tborder-style: solid;\n\t", "\n\n\tcolor: ", ";\n\tfont-weight: 500;\n\tfont-size: ", ";\n\tborder-radius: ", ";\n\tcursor: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.5rem 2rem;\n\tmin-width: 9.375rem;\n\twhite-space: pre;\n\toverflow: hidden;\n\t@media (min-width: 1024px) {\n\t\tpadding: 1.125rem 2rem;\n\t\t", "\n\t}\n\n\t", "\n\topacity: ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\tbackground: ", ";\n\tbackground: ", ";\n"])), function (props) {
  return props.outlined ? '2px' : '';
}, (0, _styledSystem.variant)({
  scale: 'buttonColors'
}), function (props) {
  return props.outlined ? props.theme.colors[props.variant] : '';
}, function (props) {
  var _props$theme$fontSize, _props$theme$fontSize2;
  return "".concat((_props$theme$fontSize = (_props$theme$fontSize2 = props.theme.fontSizesAliases) === null || _props$theme$fontSize2 === void 0 ? void 0 : _props$theme$fontSize2.body) !== null && _props$theme$fontSize !== void 0 ? _props$theme$fontSize : 1, "rem");
}, function (props) {
  return props.btnShape === 'circle' ? "".concat(props.theme.borderRadii.medium, "px") : '4px';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, (0, _styledSystem.variant)({
  prop: 'btnSize',
  scale: 'buttonSizes'
}), (0, _styledSystem.variant)({
  prop: 'btnSize',
  scale: 'buttonSizes'
}), function (props) {
  return props.disabled ? '0.6' : '';
}, _styledSystem.layout, _styledSystem.space, _styledSystem.flexbox, _styledSystem.borderRadius, function (props) {
  return props.outlined ? 'transparent' : '';
}, function (props) {
  return props.bgFallback ? props.theme.colors.light : '';
});
exports.RaisedButtonStyled = RaisedButtonStyled;